import Model from "./Model";
import { Jsona } from "jsona";
import type { TJsonApiBody } from "jsona/lib/JsonaTypes";

export interface IBrand {
  id: string | null;
  name: string | null;
  slug: string | null;
  image: string | null;
  image_sm: string | null;
  isOpen: boolean;
}

export default class Brand extends Model implements IBrand {
  public id: string | null = null;
  public name: string | null = null;
  public slug: string | null = null;
  public image: string | null = null;
  public image_sm: string | null = null;
  public isOpen: boolean = false;

  public override getFilterSlug(): [string, string] | undefined {
    return ["marca", this.slug || ""];
  }

  public constructor({ id, name, slug, image, image_sm, isOpen }: IBrand) {
    super();

    this.id = id || null;
    this.name = name || null;
    this.slug = slug || null;
    this.image = image || null;
    this.image_sm = image_sm || null;
    this.isOpen = isOpen || false;
  }

  public static fromArray(items: IBrand[]): Brand[] {
    return items.map((item: IBrand) => new Brand(item));
  }

  public static async fetchWithProductExpiration(filter = "withExpiration") {
    const path = `/shop-v1/brands`;
    const filterQuery = `filter[${filter}]`;
    const query: Record<string, string> = {
      [filterQuery]: "",
      "fields[brands]": "name,image,image_sm,slug",
    };
    const queryStr = new URLSearchParams(query).toString();
    const url = path + "?" + queryStr;
    const apiFetch = useNuxtApp().$apiFetch;
    const data = await apiFetch(url);
    const jsona = new Jsona();
    const json = jsona.deserialize(data as TJsonApiBody);
    const instance = Brand.fromArray(json as IBrand[]);
    return instance;
  }

  public getImageSm() {
    return this.image_sm || this.image || undefined;
  }
}
